import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import styles from './deleteUserModal.module.scss';

interface DeleteUserModalProps {
  open: boolean;
  onClose: () => void;
  userName?: string;
  userEmail?: string;
  isDeleting?: boolean;
  onConfirm: () => void;
}

const DeleteUserModal: React.FC<DeleteUserModalProps> = ({ open, onClose, userName, userEmail, isDeleting = false, onConfirm }) => {
  const [step, setStep] = useState<1 | 2>(1);

  useEffect(() => {
    if (open) setStep(1);
  }, [open]);

  const goToConfirmStep = () => setStep(2);

  return (
    <Modal title="Delete User" open={open} onCancel={onClose} footer={null} closable={false} centered width={520} rootClassName={styles.modal}>
      {step === 1 ? (
        <div className={styles.content}>
          <p className={styles.body}>This user's account will be permanently deleted. This action cannot be undone.</p>
          <div className={styles.actions}>
            <button type="button" className={styles.btn} onClick={onClose}>
              Cancel
            </button>
            <button type="button" className={styles.btn} onClick={goToConfirmStep}>
              Continue
            </button>
          </div>
        </div>
      ) : (
        <div className={styles.content}>
          <p className={styles.body}>Please confirm you want to permanently delete this user account:</p>
          <p className={styles.userName}>{userName}</p>
          <p className={styles.userEmail}>{userEmail}</p>
          <div className={styles.actions}>
            <button type="button" className={styles.btn} onClick={onClose} disabled={isDeleting}>
              Cancel
            </button>
            <button type="button" className={styles.btnDanger} onClick={onConfirm} disabled={isDeleting}>
              {isDeleting ? 'Deleting…' : 'Confirm Delete'}
            </button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default DeleteUserModal;
